import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { DetalleOrdenCompraDTO } from "app/main/apps/shared/interfaces/detalle-orden-compra.interface";
import { FacturaDTO } from "app/main/apps/shared/interfaces/factura.interface";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { FacturaService } from "app/main/apps/shared/services/rest/factura.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";

import { OrdenesCompraService } from "app/main/apps/shared/services/rest/orden-compra.service";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import { DialogAsociarInformeComponent } from "../../oocc/components/dialog-asociar-informe/dialog-asociar-informe.component";
import { DialogAsociarRocgesComponent } from "../../oocc/components/dialog-asociar-rocges/dialog-asociar-rocges.component";

@Component({
    selector: "app-detalle-oocc",
    templateUrl: "./detalle-oocc.component.html",
    styleUrls: ["./detalle-oocc.component.scss"],
    animations: fuseAnimations,
})
export class DetalleOoccComponent implements OnInit, OnDestroy {
    subscripciones: Subscription;
    idOOCC: number;
    oocc: DetalleOrdenCompraDTO;
    origen:string="ordencompra";
    constructor(
        private _activatedRouteSrv: ActivatedRoute,
        private _ooccSrvc: OrdenesCompraService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _dialogSrvc: DialogService,
        private _ordenesCompraSrvc: OrdenesCompraService,
        private _notificacionSrvc: NotificacionesService,
        private _router: Router,
        private _facturaSrvc: FacturaService
    ) {
        this.subscripciones = new Subscription();
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._activatedRouteSrv.params.subscribe((params) => {
                if (Object.keys(params).length > 0) {
                    this.idOOCC = params["idOOCC"];
                    this.getDetalleOOCC();
                }
            })
        );
    }

    getDetalleOOCC() {
        this._fuseProgressBarService.show();
        this._ooccSrvc
            .fetchOrdenCompra(this.idOOCC)
            .pipe(finalize(() => this._fuseProgressBarService.hide()))
            .subscribe((resp) => (this.oocc = resp));
    }

    guardarRocGes(event) {

        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAsociarRocgesComponent,
            "clase-dialog",
            "700px",
            {
                numeroGes: event.numeroGes,
                idOOCC: this.idOOCC,
                tieneImagen:this.oocc.recepcion?.filename
            }
        ); 

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (event.nuevo) {
                    let c = this._ordenesCompraSrvc
                        .saveNumeroGes(result.informe,result.form.numero, this.idOOCC)
                        .subscribe((resp) => {
                            this._ordenesCompraSrvc.ooccRefresh$.next(true);
                            this.getDetalleOOCC();
                            this._notificacionSrvc.mostrarNotificacion(
                                "Recepcion guadardad exitosamente", "success"
                            );
                        });
                } else {
                    let c = this._ordenesCompraSrvc
                        .updateNumeroGes(result.informe, result.form.numero, this.idOOCC)
                        .subscribe((resp) => {
                            this._ordenesCompraSrvc.ooccRefresh$.next(true);
                            this.getDetalleOOCC();
                            this._notificacionSrvc.mostrarNotificacion(
                                "Recepcion guadardad exitosamente", "success"
                            );
                        });
                }
            }
        });
    }

    asociarDocumento(event) {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAsociarInformeComponent,
            "clase-dialog",
            "700px",
            {titulo:'Informe ROC-GES'}
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result){
                let c = this._ordenesCompraSrvc.saveFile(result,this.idOOCC)
                    .subscribe((resp) => {
                        this._ordenesCompraSrvc.ooccRefresh$.next(true);
                        this.getDetalleOOCC();
                    });
            }
        });
    }

    anular(idOOCC:number) {
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Anular Orden Compra",
            "¿Está seguro que quiere anular la Orden de Compra?"
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) { 
                this._ordenesCompraSrvc.delete(idOOCC)
                    .subscribe((resp) => {
                        //TODO La respuesta siempre es null, avisar
                        //console.log(resp);
                        this._notificacionSrvc.mostrarNotificacion(
                            "Orden de Compra anulada",
                            "success"
                        );
                        this._router.navigateByUrl("/ordenes-de-compra");
                    });
            }
        });
    }

    async bajarDocumento(idOOCC:number){
        this._ordenesCompraSrvc.fetchDocumento(idOOCC).subscribe(blob=>{
            const a = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            a.setAttribute('download', 'DocumentoOOCC_' + idOOCC);
            a.href = url;
            a.click();
        })
    }

    bajarInforme(idOOCC:number){
        //console.log('llego a bajar informe');
        //console.log(idOOCC);
        this._ordenesCompraSrvc.fetchInforme(idOOCC).subscribe(blob=>{
            const a = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            a.setAttribute('download', 'InformeOOCC_' + idOOCC);
            a.href = url;
            a.click();
        })
    }


    adjuntarInforme(idOOCC:number){
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAsociarInformeComponent,
            "clase-dialog",
            "700px",
            {titulo:'Informe Orden de Compra'}
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result){
                let c = this._ordenesCompraSrvc.saveInforme(idOOCC,result)
                    .subscribe((resp) => {
                        this._ordenesCompraSrvc.ooccRefresh$.next(true);
                        this.getDetalleOOCC();
                    });
            }
        });
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }

    cambiarEstadoFactura(factura: FacturaDTO) {
        //console.log(factura);
        if (factura.pagada) {
            const dialogRef = this._dialogSrvc.abrirDialogConfirm(
                "Factura impaga",
                "¿Está seguro que quiere cambiar el estado de la factura a impaga"
            );

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this._facturaSrvc
                        .unregisterPago(factura.idFactura)
                        .subscribe((resp) => {
                            this.oocc.factura.pagada = false;
                            this._facturaSrvc.facturaChanged$.next(this.oocc.factura);

                            this._notificacionSrvc.mostrarNotificacion(
                                "Factura fue marcada como impaga",
                                "success"
                            );
                            
                        });
                }
                else{
                    this._facturaSrvc.facturaChanged$.next(this.oocc.factura);
                }
            });
        } else {
            const dialogRef = this._dialogSrvc.abrirDialogConfirm(
                "Factura Pagada",
                "¿Está seguro que quiere cambiar el estado de la factura a pagada"
            );

            dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    this._facturaSrvc
                        .registerPago(factura.idFactura)
                        .subscribe((resp) => {
                            this.oocc.factura.pagada = true;
                            this._facturaSrvc.facturaChanged$.next(this.oocc.factura);
                            this._notificacionSrvc.mostrarNotificacion(
                                "Factura fue marcada como pagada",
                                "success"
                            );
                            //this._router.navigateByUrl("/facturas/"+this.factura.idFactura);

                        });
                }
                else{
                    this._facturaSrvc.facturaChanged$.next(this.oocc.factura);
                }
            });
        }
    }

}
